import React from 'react';
import PropTypes from 'prop-types';
var ToneFeedback = function ToneFeedback(_ref) {
  var onYesClick = _ref.onYesClick,
    onNoClick = _ref.onNoClick,
    yesButtonLabel = _ref.yesButtonLabel,
    noButtonLabel = _ref.noButtonLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: "tone-player"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tone-player__buttons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "step-button like-orange-button-large",
    onClick: function onClick(e) {
      e.preventDefault();
      onNoClick();
    }
  }, noButtonLabel), /*#__PURE__*/React.createElement("button", {
    className: "step-button like-orange-button-large",
    onClick: function onClick(e) {
      e.preventDefault();
      onYesClick();
    }
  }, yesButtonLabel)));
};
ToneFeedback.propTypes = {
  onYesClick: PropTypes.func.isRequired,
  onNoClick: PropTypes.func.isRequired,
  yesButtonLabel: PropTypes.string,
  noButtonLabel: PropTypes.string
};
ToneFeedback.defaultProps = {
  yesButtonLabel: 'Yes',
  noButtonLabel: 'No'
};
export default ToneFeedback;